import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ZakresDat } from '../../shared/models/zakres-dat.model';
import { FormatowanieDatService } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class WydrukcService {

  constructor(
    private http: HttpClient,
    private formatowanieDat: FormatowanieDatService,
  ) { }

  drukujKPiR(zakresDat: ZakresDat) {
    const params = new HttpParams()
        .set('dataOd', this.formatowanieDat.format(zakresDat.dataOd))
        .set('dataDo', this.formatowanieDat.format(zakresDat.dataDo));

    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');

    return this.http.get('/api/wydruk/kpir', { params: params, headers: headers, responseType: 'blob' });
  }

  drukujEwidencjeRyczaltu(zakresDat: ZakresDat) {
    const params = new HttpParams()
        .set('dataOd', this.formatowanieDat.format(zakresDat.dataOd))
        .set('dataDo', this.formatowanieDat.format(zakresDat.dataDo));

    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');

    return this.http.get('/api/wydruk/ryczalt', { params: params, headers: headers, responseType: 'blob' });
  }
}
